import React from "react";
import TableCell from "../TableCell";
import RefDataLabel from "../Components/RefDataLabel";

const ProtectionSpecification = ({
  data,
  idField,
  enableEdit,
  editFlag,
}) => {
  if (!data) return null;

  return (
    <div className="table-responsive mt-2">
      <table className="table table-bordered table-sm mb-0">
        <thead className="table-light">
          <tr>
            <th style={{ width: "30%" }}>Label</th>
            <th style={{ width: "40%" }}>
              <RefDataLabel
                        label=" PPE Item(s)"
                        isRefData={true}
                      />
             </th>
            <th style={{ width: "30%" }}>PPE Item Notes</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            {/* Label */}
            <td>
              {data.internalLabel ? (
                <TableCell
                  enableEdit={enableEdit}
                  editFlag={editFlag}
                  data={data.internalLabel}
                  idField={`${idField}.internalLabel`}
                />
              ) : (
                "-"
              )}
            </td>

            {/* PPE Items */}
            <td>
              {data.ppeItem && data.ppeItem.length > 0 ? (
                data.ppeItem.map((item, index) => (
                  <div key={index} style={{ marginBottom: "1rem" }}>
                    <TableCell
                      enableEdit={enableEdit}
                      editFlag={editFlag}
                      data={item.label}
                      idField={`${idField}.ppeItem[${index}].label`}
                    />
                   {(item.reusable !== null && item.reusable !== undefined) && (
                      <>
                        <b>Is Reusable: </b>
                        {JSON.stringify(item.reusable)}
                      </>
                    )}
                     
                  </div>
                ))
              ) : (
                "-"
              )}
            </td>

            {/* PPE Notes */}
            <td>
              {data.ppeItemNotes ? (
                <TableCell
                  enableEdit={enableEdit}
                  editFlag={editFlag}
                  data={data.ppeItemNotes}
                  idField={`${idField}.ppeItemNotes`}
                />
              ) : (
                "-"
              )}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default ProtectionSpecification;